module.exports = __webpack_public_path__ + "img/regolestorie01.685ca5d8.png";